export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

export function normalize(value: number, min: number, max: number): number {
  const clampedValue = clamp(value, min, max);
  return (clampedValue - min) / (max - min);
}
